/* eslint-disable no-param-reassign */
import FormioUtils from '@formio/js/utils';
import React from 'react';
import { get as _get } from 'lodash';
import api from '../../shared/api';
import { getFormKeysForSiteByType, PermitTypes } from '../../shared/permits';

const setIsCloseOut = (component) => ({ ...component, isCloseOut: true });
const setIsOperationData = (component) => ({ ...component, isOperationalData: true });

/**
 * Flag fields and their children in order to be able to identify and perform effects
 * further down the tree
 *  * @param {FormState} formState - State of form APPROVED, TIMED-OUT etc
 * @return {(Component) => Component)} - A function the takes a component ref and returns the ref modified or not
 */
export const flagFields = (formState) => (component) => {
  if (component.key === 'closeOut' || component.isCloseOut || _get(component, 'properties.CloseOut', '') === 'true') {
    component.isCloseOut = true;
    if (component.components) component.components = component.components.map(setIsCloseOut);
    if (component.columns) component.columns = component.columns.map(setIsCloseOut);
    if (component.rows && Array.isArray(component.rows)) component.rows = component.rows.map(setIsCloseOut);
  }

  if (
    component.key === 'OperationalData'
    || component.isOperationalData
    || _get(component, 'properties.OperationalData', '') === 'true'
  ) {
    component.isOperationalData = true;
    // eslint-disable-next-line no-unused-expressions
    if (component.components) component.components = component.components.map(setIsOperationData); if (component.label === "Upload - Signed Paper Copy" && formState === 'APPROVED') component.validate = { required: true }
    if (component.components) component.components = component.components.map(setIsOperationData); if (component.label === "First Designated - Field Operator / Equipment / Area Prepared / Verified" && formState === 'APPROVED') component.validate = { required: true }
    if (component.components) component.components = component.components.map(setIsOperationData); if (component.label === "First Designated - Permit Receiver" && formState === 'APPROVED') component.validate = { required: true }
    if (component.components) component.components = component.components.map(setIsOperationData); if (component.label === "Second Designated - Field Operator / Equipment / Area Prepared / Verified" && formState === 'APPROVED') component.validate = { required: true }
    if (component.components) component.components = component.components.map(setIsOperationData); if (component.label === "Second Designated - Permit Receiver" && formState === 'APPROVED') component.validate = { required: true }
    if (component.columns) component.columns = component.columns.map(setIsOperationData);
    if (component.rows && Array.isArray(component.rows)) component.rows = component.rows.map(setIsOperationData);
  }

  return component;
};

/**
 * Disables components in the form based on the state the permit is in
 * @param {FormState} formState - State of form APPROVED, TIMED-OUT etc
 * @return {(Component) => Component)} - A function the takes a component ref and returns the ref modified or not
 */
export const disabledFields = (formState, hasEditPermissions, Location, data) => (component) => {
  let locationId = Location?.LocationId;
  let siteId = Location?.SiteId;
  console.log(siteId)

  if (data) {
    let restrictedHotWorkChecklist = data?.ContentJSON?.data?.restrictedHotWorkChecklistGeismar;
    let prePlanningApprovalChecklist = data?.ContentJSON?.data?.prePlanningApprovalChecklist;
    console.log("restrictedHotWorkChecklist" + restrictedHotWorkChecklist)
    console.log("prePlanningApprovalChecklist" + prePlanningApprovalChecklist)
    if (prePlanningApprovalChecklist && restrictedHotWorkChecklist) {
      if (component.key === 'prePlanningApprovalPhase') {
        component.hidden = true;
      }

    }
  }
  if (!hasEditPermissions) {
    component.disabled = true;
    return component;
  }
  if (component.key === 'workOrder') {
    component.disabled = true;
  }

  if (component.key === 'workOrderSubOperations') {

    const isLockedByState = ['APPROVED', 'COMPLETED'].includes(formState);
    component.disabled = isLockedByState;
    component.disabledByState = isLockedByState;
    return component;
  }
  if (formState === 'DRAFT') {
    return component;
  }


  // setting a display/layout/subform component to disabled has a side effect where it
  // breaks conditional 'viewWhen' logic
  if (['panel', 'well', 'columns', 'row', undefined, 'form'].includes(component.type)) {
    return component;
  }
  // A user should never be able to change the safe work permit number
  if (component.key === 'safeWorkPermitNumber') {
    component.disabled = true;
    return component;
  }

  //remove disable field in approved stage 
  if (formState === 'APPROVED' && component.label === "Print Name" && locationId === 210200) {
    component.disabled = false;
    console.log(component);
    return component;
  }

  if (formState === 'APPROVED' && locationId === 210200) {
    if (component.label === "Time" ||
      component.label === "Oxygen" ||
      component.label === "LEL" ||
      component.label === "CO" ||
      component.label === "H2S" ||
      component.key === "lelInitialReadings" ||
      component.key === "H2SInitialReadings") {
      component.disabled = false;
      return component;
    }
  }

  // Operational data fields are editable during an in progress template
  if (['APPROVED', 'TIMEOUT'].includes(formState) && component.isOperationalData) {
    return component;
  }

  // readyToComplete is editable in both APPROVED and TIMEOUT states
  if (['APPROVED', 'TIMEOUT'].includes(formState) && component.key === 'readyToComplete') {
    component.disabled = false;
    return component;
  }

  if (siteId === 1) {
    // remove disable field in approved stage 
    if (formState === 'APPROVED' && component.label.includes("Additional Reading")) {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && component.label === "Time") {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && component.label === "Sampled by") {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && (component.label === "O2 (20–22%)" || component.label === "O2")) {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && (component.label === "LEL/LFL (LEL/LFL <10%)" || component.label === "LEL/LFL")) {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && (component.label === "CO (<25 ppm)" || component.label === "CO")) {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && component.label === "Temperature") {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && component.label === "Other") {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && component.label === "Field Set") {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' && component.label === "Table") {
      component.disabled = false;
      return component;
    }
    if (formState === 'APPROVED' &&
      (component.label === "Print Name" ||
        component.label === "In" ||
        component.label === "Out" ||
        component.label === "Personal Lock On?")) {
      component.disabled = false;
      return component;
    }

    // if (formState === 'APPROVED' && component.label.includes("Upload - Signed Paper Copy")){
    //     component.disabled = false;
    //     component.validate= {required: true};
    // }
    // else{
    //   component.validate= {required: false};
    // }
  }

  // Close out fields are still during work progress
  if (component.isCloseOut && ['APPROVED', 'TIMEOUT', 'CLOSING'].includes(formState)) {
    return component;
  }

  // The submit button is required when a permit is in progress or timed out so reliving can be updated
  if (['APPROVED', 'TIMEOUT'].includes(formState) && component.input && component.key === 'submit') {
    return component;
  }

  // The approvalToProceed container being disabled overrides children components that are enabled
  // so we enable it so the reliving operator can be enabled
  if (formState === 'APPROVED' && component.key === 'approvalToProceed') {
    return component;
  }

  // Enable the reliving operator fields for an approved/active permit
  if (formState === 'APPROVED' && _get(component, 'properties.ApprovalRelief', '') === 'true') {
    return component;
  }

  // Fire Watch Log name fields remain editable in APPROVED state
  if (formState === 'APPROVED' && ['name1FireWatchLog', 'name2FireWatchLog', 'name3FireWatchLog', 'name4FireWatchLog'].includes(component.key)) {
    component.disabled = false;
    return component;
  }

  // Otherwise, unless the permit has not been approved all fields should be disabled
  if (!['PRE-APPROVAL', 'PENDING'].includes(formState)) {
    component.disabled = true;
  }

  return component;
};

/**
 * Populates any fields related to the workOrder in the permit form.
 * These fields have an entry in component.properties where { ErpMapping: workOrderFieldName }
 * the workOrderFieldName value is used as the match key in the form tree
 *
 * @param {Form} form - Reference to FormIo form
 * @param {FormChangeEvent} event - The onChange event callback response
 * @return void
 */
export const hideComponent = (form, event) => {
  // if (form && event.changed){
  if (form && event.changed) {
    const components = form.getComponent("safeWork") ? form.getComponent("safeWork") : undefined;
    const prePlanningApproval = form?.getComponent("prePlanningApprovalPhase");
    const restrictedHotWorkChecklistGeismar = components?._data?.restrictedHotWorkChecklistGeismar;
    if (restrictedHotWorkChecklistGeismar && prePlanningApproval) {
      prePlanningApproval.component.hidden = components._data.prePlanningApprovalChecklist;
      console.log(prePlanningApproval);
      prePlanningApproval.rebuild();
    }
    if (components?._data.confinedSpace1) {
      const confinedSpaceEntryPanelGeismar = form.getComponent("confinedSpaceEntryPanelGeismar");
      let safetyDepartmentApproval = confinedSpaceEntryPanelGeismar.getComponent("authorization2");
      if (components?._data.classBConfinedSpace) {
        safetyDepartmentApproval.component.hidden = true;
      }
      if (components?._data.classAConfinedSpace) {
        safetyDepartmentApproval.component.hidden = false;
      }
    }
  }

}

/**
 * Disables all components in the tree
 * @return {(Component) => Component)} - A function the takes a component ref and returns the ref modified or not
 */
export const disableAllFields = () => (component) => {
  // setting a panel to disabled has a side effect where it breaks conditional 'viewWhen' logic
  if (component.type === 'panel') {
    return component;
  }

  component.disabled = true;
  return component;
};


/**
 * Populates the work orders dropdown
 * @param {WorkOrder} workOrder - selected work order
 * @param {string} selected - The workOrderId that is to be selected
 * @return {(Component) => Component)} - A function the takes a component ref and returns the ref modified or not
 */
export const populateWorkOrderFields = (workOrder) => (component) => {
  if (workOrder) {
    if (component.key === 'workOrder') {
      component.data.json = Array.from([workOrder])
      component.defaultValue = workOrder.workOrderNumber;
      component.value = workOrder.workOrderNumber;
      component.dataValue = workOrder.workOrderNumber;
      // component.disabled = true;
    }

    if (component.key === 'workOrderSubOperations' && Array.isArray(workOrder.operations)) {
      component.data.json = [...workOrder.operations];
    }
  }

  return component;
};

/**
 * Populates the safe work permit number in the different form resrouces (subforms)
 * @param {string[]} fields - List of work orders
 * @param {string|number} permitNumber - The safe work permit number
 * @return {(Component) => Component)} - A function the takes a component ref and returns the ref modified or not
 */
export const populateSafeWorkPermitNumber = (fields, permitNumber) => (component) => {
  if (component && fields.includes(component.key)) {
    component.defaultValue = Number(permitNumber);
    component.disabled = true;
  }
  return component;
};

/**
 * Handles the population of operations fields in the permit form
 *
 * @param {Form} form - Reference to FormIo form
 * @param {FormChangeEvent} event - The onChange event callback response
 * @param {formio.SelectInput} operationsDropdown - The formio operations dropdown
 * @param {ErpField[]} erpFields - Collection of Erp fields to use for mapping to a work order field
 * @param {WorkOrder} workOrder - The selected work order from the work order dropdown
 *
 * @return void
 */
export const populateOperationsFields = (form, event, operationsDropDown, erpFields) => {
  const components = form.flattenComponents();

  Object.keys(components).forEach((key) => {
    const component = components[key];
    if (!component) return;

    const mapping = _get(component.component.properties, 'ErpMapping');
    if (mapping) {
      const selectedOperation = operationsDropDown.choices.getValue(true);
      if (!selectedOperation) return;

      // Handle both single value and array of values
      const selectedOperations = Array.isArray(selectedOperation) ? selectedOperation : [selectedOperation];

      const field = erpFields.find((e) => e.PropertyValue === mapping);
      if (!field) return;

      // Collect all matching operations
      const operations = selectedOperations.map(selectedOp =>
        operationsDropDown.component.data.json.find((o) => o.operationNumber === selectedOp)
      ).filter(Boolean); // Remove undefined values

      if (operations.length > 0) {
        if (field.PropertyValue === 'operationDescription') {
          // Handle multiple operation descriptions
          const descriptions = operations.map(operation => {
            let description = operation.operationDescription;
            if (Array.isArray(description)) {
              description = description.join(', ');
            }
            return `${operation.operationNumber} - ${description}`;
          });

          // Set the combined value - join with semicolon or newline
          component.setValue(descriptions.join('\n'));
        } else {
          const validOperations = operations.filter(operation =>
            operation && operation[field.PropertyValue]
          );

          if (validOperations.length > 0) {
            const values = validOperations.map(operation => operation[field.PropertyValue]);
            component.setValue(values.join(', '));
          }
        }
      }
    }
  });
};

/**
 * When a permit is attached, set any ErpMapping field values form the selected work order
 *
 * @param {Form} form - Reference to FormIo form
 * @param {FormChangeEvent} event - The onChange event callback response
 * @param {ErpField[]} erpFields - Collection of Erp fields to use for mapping to a work order field
 * @return void
 */
export const populateWorkOrderFieldsOnFormAttach = (form, event, erpFields, workOrder) => {
  if (event.changed && _get(event.changed.component, 'properties.TogglesPermitDisplay')) {

    const selectedWorkOrder = _get(event.data, 'workOrder');

    if (!selectedWorkOrder || !workOrder) return;

    const permitDataKey = _get(event.changed.component, 'properties.PermitDataKey');
    const subFormComponent = FormioUtils.getComponent(form.components, permitDataKey);
    if (!subFormComponent) return;

    const formPromise = subFormComponent.subForm
      ? Promise.resolve(subFormComponent.subForm)
      : subFormComponent.createSubForm();

    formPromise.then((subForm) => {
      const components = subForm.flattenComponents();
      subFormComponent.setValue(subFormComponent.subForm.submission);

      Object.keys(components).forEach((key) => {
        const component = components[key];
        if (!component) return;

        const mapping = _get(component.component.properties, 'ErpMapping');

        if (mapping) {
          const field = erpFields.find((e) => e.PropertyValue === mapping);
          if (field) {
            component.setValue(workOrder[field.PropertyValue], { resetValue: true });
          }
        }
      });
    }).then(() => {
      const operationsDropDown = form.getComponent('workOrderSubOperations');

      if (operationsDropDown && operationsDropDown.dataValue) {
        populateOperationsFields(form, event, operationsDropDown, erpFields, workOrder);
      }
    });

  }
};

/**
 * Populates any fields related to the workOrder in the permit form.
 * These fields have an entry in component.properties where { ErpMapping: workOrderFieldName }
 * the workOrderFieldName value is used as the match key in the form tree
 *
 * @param {Form} form - Reference to FormIo form
 * @param {FormChangeEvent} event - The onChange event callback response
 * @return void
 */
export const updateFieldsOnWorkOrderChange = (form, event, erpFields) => {
  // ensure all the information we need is here and it was the workOrder dropdown that changed
  if (form && erpFields && event.changed && event.changed.component.key === 'workOrder' && event.changed.value) {
    // find the selected work order from the dropdown

    if (!Array.isArray(event.changed.component.data.json)) {
      return
    }

    const workOrder = event.changed.component.data.json.find((w) => w.workOrderNumber === String(event.changed.value));
    const componentMap = form.flattenComponents();

    // loop through the fields in the form looking for fields that have the custom property key "ErpMapping".
    // For fields that have this key, find the associated field by the PathPointer available in the erpFields param
    for (const componentKey in componentMap) {
      const component = componentMap[componentKey];

      // Create the subform, and then loop through it's components
      // and set the value based on the erpFields.
      // Otherwise it is a regular, loaded component so we perform a simple look up
      // to see if there is a matching erpField
      if (component.type === 'form' && component.visible) {
        // Depending on if the panel containing the subform is expaned, it will have a populated
        // subform. If it doesn't have a subform, create it. Once created, flatten the subform components
        // and loop through performing the same action to find ErpMapping fields and set their values.
        let formPromise = component.subForm
          ? Promise.resolve(component.subForm)
          : component.createSubForm();

        formPromise.then(subForm => {
          const components = subForm.flattenComponents();

          Object.keys(components).forEach(key => {
            const component = components[key];
            if (!component) return

            const mapping = _get(component.component.properties, 'ErpMapping');

            if (mapping) {
              const field = erpFields.find(e => e.PropertyValue === mapping);
              field && component.setValue(workOrder[field.PropertyValue])
            }
          });
        })
      } else {
        const mapping = _get(component.component.properties, 'ErpMapping');

        if (mapping) {
          const field = erpFields.find(e => e.PropertyValue === mapping);
          field && component.setValue(workOrder[field.PropertyValue])
        }
      }
    }
  }
}

/**
 * Populates any fields related to the workOrder in the permit form.
 * These fields have an entry in component.properties where { ErpMapping: workOrderFieldName }
 * the workOrderFieldName value is used as the match key in the form tree
 *
 * @param {Form} form - Reference to FormIo form
 * @param {FormChangeEvent} event - The onChange event callback response
 * @return void
 */
export const updateLinkedPermitFields = async (form, event, locationId) => {
  if (form && event.changed && _get(event.changed.component, 'properties.SelectFromPermitType')) {
    const permitDataKey = _get(event.changed.component, 'properties.PermitDataKey');
    const component = form.getComponent(permitDataKey);
    const changedComponentKey = _get(event.changed.component, 'key');

    if (['', 'createNewPermit'].includes(event.changed.value)) {
      component.options = {
        ...component.options,
        readOnly: false,
      };
      if (component.subForm) {
        component.subForm.submission = {
          data: {},
        };
        component.dataValue = {};
        component.subForm.disabled = false;
        component.subForm.options.readOnly = false;
        component.subForm.rebuild();
      }
    } else {
      // Fetch the content of the permit to attach
      const { Content, PermitNumber } = await api.get(`/permitcontent?PermitInstanceId=${event.changed.value}`);
      const linkedPermitData = Content.data[permitDataKey];

      if (linkedPermitData) {
        const permitKeys = getFormKeysForSiteByType(locationId, PermitTypes.WorkPermit);

        // rebuild the data and the submission object and update the form.
        const structuredPermitData = {
          metadata: linkedPermitData.metadata,
          data: {
            ...linkedPermitData.data,
            permitNumber: PermitNumber,
            safeWorkPermitNumber: _get(form.submission, `${permitKeys.form}.data.safeWorkPermitNumber`, undefined),
          },
        };

        if (component.subForm) {
          component.subForm.disabled = true;
        }

        if (locationId === 17 && PermitNumber && changedComponentKey === 'selectConfinedSpaceAuthorization' && form.getComponent("authorizationNumberConfinedSpace")) {
          form.getComponent("authorizationNumberConfinedSpace").setValue(PermitNumber);
        }

        if (locationId === 17 && PermitNumber && changedComponentKey === 'selectFireWaterAuthorization' && form.getComponent("authorizationNumberFireWater")) {
          form.getComponent("authorizationNumberFireWater").setValue(PermitNumber);
        }

        if (locationId === 17 && PermitNumber && changedComponentKey === 'selectRoadClosureAuthorization' && form.getComponent("authorizationNumberRoadClosure")) {
          form.getComponent("authorizationNumberRoadClosure").setValue(PermitNumber);
        }

        if (locationId === 17 && PermitNumber && changedComponentKey === 'selectExcavationAuthorization' && form.getComponent("authorizationNumberExcavation")) {
          form.getComponent("authorizationNumberExcavation").setValue(PermitNumber);
        }

        if (locationId === 17 && PermitNumber && changedComponentKey === 'selectStockpileAuthorization' && form.getComponent("authorizationNumberStockpileArea")) {
          form.getComponent("authorizationNumberStockpileArea").setValue(PermitNumber);
        }

        component.options = {
          ...component.options,
          readOnly: true,
        };

        component.setValue(structuredPermitData);
        if (component.subForm) {
          component.subForm.redraw();
        }
      }
    }
  }
};

/**
 * Populates the operations dropdown when teh selected work order changes
 *
 * @param {Form} form - Reference to FormIo form
 * @param {FormChangeEvent} event - The onChange event callback response
 * @param {formio.SelectInput} operationsDropdown - The formio operations dropdown
 * @param {ErpField[]} erpFields - Collection of Erp fields to use for mapping to a work order field
 * @param {WorkOrder} workOrder - selected work order
 *
 * @return void
 */
export const populatedOperationsSelect = (form, event, erpFields, workOrder) => {
  if (form && event.changed && workOrder && _get(event.changed.component, 'key') === 'workOrder') {
    const operationsDropDown = form.getComponent('workOrderSubOperations');

    if (!operationsDropDown) {
      return;
    }
    operationsDropDown.setValue('');
    operationsDropDown.choices.clearChoices();

    if (!workOrder || !Array.isArray(workOrder.operations)) {
      return;
    }

    operationsDropDown.component.data = {
      json: [...workOrder.operations],
    };

    operationsDropDown.addCurrentChoices(workOrder.operations);
    populateOperationsFields(form, event, operationsDropDown, erpFields, workOrder);
  }
};

/**
 * Updates the permit form fields when the selected operation changes
 *
 * @param {Form} form - Reference to FormIo form
 * @param {FormChangeEvent} event - The onChange event callback response
 * @param {formio.SelectInput} operationsDropdown - The formio operations dropdown
 * @param {ErpField[]} erpFields - Collection of Erp fields to use for mapping to a work order field
 * @param {WorkOrder} workOrder - selected work order
 *
 * @return void
 */
export const updateOperationsFields = (form, event, erpFields, workOrder) => {
  if (form && event.changed && _get(event.changed.component, 'key') === 'workOrderSubOperations') {
    const operationsDropDown = form.getComponent('workOrderSubOperations');

    if (operationsDropDown && workOrder) {
      populateOperationsFields(form, event, operationsDropDown, erpFields, workOrder);
    }
  }
};

/**
 * Updates the work order related select boxes in a form
 *
 * @param {Form} form - Reference to FormIo form
 * @param {WorkOrder} workOrder - selected work order
 *
 * @return void
 */
export const updateSelectedWorkOrderInForm = (form, workOrder) => {
  const workOrderComponent = form.getComponent('workOrder');
  if (workOrderComponent) {
    workOrderComponent.choices.clearChoices();

    if (workOrder) {
      workOrderComponent.addCurrentChoices(Array.from([workOrder]));
      workOrderComponent.component.data.json = Array.from([workOrder])
      workOrderComponent.setValue(workOrder.workOrderNumber);
    }
    else {
      workOrderComponent.component.data.json = [];
      workOrderComponent.setValue(undefined);
    }

    const operationsDropDown = form.getComponent('workOrderSubOperations');

    if (!operationsDropDown) {
      return
    }
    const lockedByState = Boolean(operationsDropDown.component && operationsDropDown.component.disabledByState);

    operationsDropDown.choices.clearChoices();
    operationsDropDown.setValue(undefined);
    if (workOrder && Array.isArray(workOrder.operations) && workOrder.operations.length > 0) {
      const operations = Array.from(workOrder.operations);
      operationsDropDown.addCurrentChoices(operations);
      operationsDropDown.component.data.json = operations;

      operationsDropDown.disabled = lockedByState;
      operationsDropDown.component.disabled = lockedByState;


    } else {
      operationsDropDown.component.data.json = [];
      operationsDropDown.disabled = true;
      operationsDropDown.component.disabled = true;
    }
  }
}

/**
 * Disable permit form for attached permit
 *
 * @param {Form} form - Reference to FormIo form
 * @param {contentData} contentData - selected permit data
 *
 * @return void
 */


export const applyDisableEffectToPermit = (form, contentData) => {

  if (!contentData || !form) return;

  const components = form.flattenComponents();
  Object.keys(components).forEach((key) => {
    const component = components[key];
    if (!component) return;

    if (_get(component.component, 'properties.SelectFromPermitType')) {
      const permitDataKey = _get(component.component, 'properties.PermitDataKey');
      if (contentData[component.component.key]) {
        const targetComponent = form.getComponent(permitDataKey);
        if (targetComponent.component) {
          targetComponent.component.disabled = true;
        }
      }
    }
  });
};

export const updateFormFieldToSubForm = async (form, event) => {
  if (!event.changed) return;
  const broadcastProperties = _get(event.changed.component, 'properties.broadcastValueToSubscriber')
  if (event.changed && broadcastProperties) {

    form.everyComponent(c => {
      const subscribeProperties = _get(c.component, 'properties.subscribeValueFromSource');
      if (subscribeProperties === broadcastProperties) {
        c.setValue(event.changed.value)
      }

    });
  };


  if (_get(event.changed.component, 'properties.TogglesPermitDisplay')) {

    const permitDataKey = _get(event.changed.component, 'properties.PermitDataKey');
    const subFormComponent = FormioUtils.getComponent(form.components, permitDataKey);
    if (!subFormComponent) return;

    const formPromise = subFormComponent.subForm
      ? Promise.resolve(subFormComponent.subForm)
      : subFormComponent.createSubForm();
    formPromise.then((subForm) => {

      const components = subForm.flattenComponents();
      subFormComponent.setValue(subFormComponent.subForm.submission);
      Object.keys(components).forEach((key) => {
        const component = components[key];
        if (!component) return;

        const subscribeProperties = _get(component.component.properties, 'subscribeValueFromSource');

        if (subscribeProperties) {
          form.everyComponent(c => {
            const broadcastProperties = _get(c.component, 'properties.broadcastValueToSubscriber');
            if (subscribeProperties === broadcastProperties) {
              const value = form._data[c.path]
              component.setValue(value)
            }
          })
        }

      });
    });

    if (subFormComponent && subFormComponent.redraw) {
      subFormComponent.redraw()
    }

  }

}

export const setInitValueInForm = (form) => {
  if (!form) return;
  form.everyComponent(comp => {
    const broadcastProperties = _get(comp.component, 'properties.broadcastValueToSubscriber');
    if (broadcastProperties) {
      form.everyComponent(c => {
        const subscribeProperties = _get(c.component, 'properties.subscribeValueFromSource');
        if (subscribeProperties === broadcastProperties) {
          const value = form._data[comp.path]
          c.setValue(value)
        }
      })
    }
  });
}

export const getErrorList = (form) => {
  const error = [];
  let count = 0;
  try {
    form.components.forEach((data) => {
      if (data.components && data.errors.length) {
        const errors = data.errors.map((e) => {
          return {
            label: e.message,
            key: e.component.key,
            name: e.component.name,
            id: e.component.id,
            inputType: e.component.inputType,
            path: e.formattedKeyOrPath
          }
        });
        const errorMessage = [];
        errors.forEach(data => {
          if (data.inputType === 'radio') {
            if (!errorMessage.find(a => a.name === data.name)) {
              const msg = `${data?.name?.replace(/([a-z])([A-Z])/g, '$1 $2')} is required`.toLowerCase();
              errorMessage.push({
                ...data,
                label: msg.charAt(0).toUpperCase() + msg.slice(1)
              })
            }
          } else if (data.inputType === 'checkbox') {
            if (!errorMessage.find(a => a.key === data.key)) {
              const msg = `${data?.key?.replace(/([a-z])([A-Z])/g, '$1 $2')} is required`.toLowerCase();
              errorMessage.push({
                ...data,
                label: msg.charAt(0).toUpperCase() + msg.slice(1)
              })
            }
          } else {
            errorMessage.push(data)
          }
        })
        count = count + errorMessage.length;
        error.push({ label: data.errorLabel, count: errorMessage.length, errorMessage })
      }
    })
  } catch (error) {
    console.log(error)
  }
  return {
    total: count,
    result: error
  }
}
